import { useRef } from "react";

const MAX_LENGTH = 500;

export default function EmojiPickerBackgrounds({
  text,
  user,
  setText,
  type2,
  background,
}) {
  const textRef = useRef(null);
  const bgRef = useRef(null);

  return (
    <div className={type2 ? "images_input" : "post_composer"}>
      <div className={!type2 ? "post_composer_box" : ""} ref={bgRef}>
        <textarea
          ref={textRef}
          maxLength={MAX_LENGTH}
          value={text}
          placeholder={`What's on your mind, ${user.first_name}?`}
          className={`post_input ${type2 ? "input2" : ""} ${
            background ? "bgHandler" : ""
          }`}
          onChange={(e) => setText(e.target.value)}
          style={{
            paddingTop: `${
              background
                ? Math.abs((textRef.current?.value.length || 0) * 0.1 - 32)
                : undefined
            }%`,
          }}
        />
        {!type2 && text.length > 0 && (
          <div className="post_composer_footer">
            <span className="post_char_count">
              {text.length}/{MAX_LENGTH}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
